module.exports = __webpack_public_path__ + "img/sangfor.e998d5a1.svg";